import { Button, Grid } from "@mui/material";
import { Field, Form, Formik, type FormikProps } from "formik";
import { TextField } from "formik-mui";
import { useTranslation } from "react-i18next";

import type { APIError } from "src/types";
import { ButtonGrid } from "src/components/form-components/ButtonGrid";
import { ButtonLoading } from "src/components/ButtonLoading";
import { ServerErrors } from "src/components/form-components/ServerErrors";
import { useCaseCopySchema } from "src/schemas/case-copy.schema";
import type { CaseCopyMutationData } from "src/hooks/caseHooks";

export type CaseCopyFormData = CaseCopyMutationData;

interface Props {
  onClose: () => void;
  onSubmit: (values: CaseCopyFormData) => void;
  isLoading: boolean;
  errors?: APIError[] | null;
  formRef?: React.MutableRefObject<FormikProps<CaseCopyFormData> | null>;
}

export function CaseCopyForm(props: Props) {
  const { t } = useTranslation();
  const validationSchema = useCaseCopySchema();

  const initialValues: CaseCopyFormData = {
    caseName: "",
  };

  return render();

  function render() {
    return (
      <Formik
        innerRef={props.formRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values: CaseCopyFormData) => {
          return props.onSubmit(values);
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Field component={TextField} name="caseName" label={t("label.name")} type="text" fullWidth />
              </Grid>

              {props.errors && (
                <Grid item xs={12}>
                  <ServerErrors data={props.errors} />
                </Grid>
              )}

              <ButtonGrid container item xs={12} sx={{ justifyContent: "flex-end" }}>
                <Button variant="text" onClick={props.onClose}>
                  {t("label.cancel")}
                </Button>
                <ButtonLoading
                  isLoading={isSubmitting || props.isLoading}
                  type="submit"
                  color="primary"
                  variant="contained"
                >
                  {t("label.save")}
                </ButtonLoading>
              </ButtonGrid>
            </Grid>
          </Form>
        )}
      </Formik>
    );
  }
}
